export const PROPERTY_CODE_PATTERN = /^[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{6}$/;

export function normalizePropertyCode(value: string): string {
  return value.trim().toUpperCase();
}

export function isValidPropertyCode(value: string): boolean {
  return PROPERTY_CODE_PATTERN.test(normalizePropertyCode(value));
}
